import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    rootGrid: {
        flexGrow: 1,
    },
	rootCard: {
		maxWidth: 250,
		height:250,
		margin:10,
		border: "4px outset grey"
	},	
	contentMedia:{
		height: 200,
		width: 200,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	media: {
		height: 200,
		width: 200,
	},
	marginBottom: {
		marginBottom: '20px',
	},	
	cardContent: {
		padding: '5px',
	},	
	cardButtons: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	centerTitle: {
        textAlign: 'center',
        // marginTop: '10px',
		fontSize: '18px',
		textTransform: 'uppercase',
        backgroundColor:'gainsboro',
    },
	centerText: {
        textAlign: 'center',
		fontSize: '18px',
		textTransform: 'uppercase',
		margin: '20px 0px',
    },
  }));
